<script>
  import { itemMixin } from './mixin'
  import NavigationItemBadge from './NavigationItemBadge'
  import NavigationItemIcon from './NavigationItemIcon'

  export default {
    name: 'navigation-item-child',

    components: {
      NavigationItemBadge,
      NavigationItemIcon
    },

    mixins: [itemMixin],

    props: {
      item: {
        type: Object,
        required: true
      }
    },

    beforeCreate () {
      this.$options.components.Item = require('./NavigationItem').default
    }
  }
</script>

<template>
  <div class="menu-item"
       :class="[{'open-item' : show}, {'active-item' : active}, {'parent-active-item' : childActive}]">
    <template>
      <router-link class="item-link"
                   :to="item.href ? item.href : ''"
                   :disabled="item.disabled"
                   :event="item.disabled ? '' : 'click'" @click.native="clickEvent">
        <navigation-item-icon :item="item"/>
        <navigation-item-badge :item="item"/>
        <span class="item-title">
          {{ item.title }}
        </span>
      </router-link>
    </template>
  </div>
</template>
